import { Component, OnInit } from '@angular/core';
import * as XLSX from 'xlsx-js-style';
import { AuditRow, AuditLogResponse } from '../../../models/Audit/audit';
import { AuditService } from '../../../services/audit.service';
import { DatePipe } from '@angular/common';
import { CommonService } from '../../../services/common/common.service';
import { CompanyService } from '../../../services/company/company.service';
import { ActivatedRoute } from '@angular/router';
import { MenuService } from '../../../services/menus/menu.service';
import { AuthService } from '../../../services/auth.service';
import moment from 'moment';

@Component({
  selector: 'app-audit',
  templateUrl: './audit.component.html',
  styleUrl: './audit.component.scss',
})
export class AuditComponent implements OnInit {
  private normalizeModuleName(value: string): string {
    return String(value ?? '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]/g, '');
  }

  private readonly excludedModules = new Set([
    'letterrequest',
    'employeetravelexpense',
    'leaverequest',
    'employeepassportrequest',
    'leaveresumption',
    'leavecancellation',
    'employeetravelrequest',
    'attendanceregularization',
    'employeetax',
    'employeelogin',
    'employeedocumentrequest',
  ]);
  logs: AuditRow[] = [];
  filters: any = {
    amendmentFrom: '',
    amendmentTo: '',
    module: null,
    searchText: '',
  };
  page: number = 1;
  size: number = 10;
  currentPage: number = 0;
  pageSize: number = 10;
  totalRecords: number = 0;
  dateFormat: any = 'dd/MM/yy';
  date: any = 'dd-mm-yy';
  angularDateFormat: string = '';
  companyName: string = '';
  viewType: 'grid' | 'list' = 'list';
  menuId: number = 0;
  myColumns: any = [];
  modules: any[] = [];
  isMenuOpen: boolean = false;

  // Custom table
  filterPayload: any = '';
  orderby: string = '';
  order: string = '';
  searchQuery: string = '';
  private searchDebounceTimer: any = null;

  constructor(
    private readonly auditService: AuditService,
    private datePipe: DatePipe,
    private commonService: CommonService,
    private companyService: CompanyService,
    private readonly menuService: MenuService,
    private readonly route: ActivatedRoute,
    private readonly auth: AuthService,
  ) { }

  ngOnInit(): void {
    this.menuId = this.auth.selectedMenuID ?? 0;
    // const menuName = this.route.snapshot.data['breadcrumb'];
    // if (menuName) {
    //   this.getMenuIdByName(menuName);
    // }
    let data: any = this.commonService.getLocalStorageData();
    if (data) {
      if (!data.client) {
        this.getDateFormat(data.companyID);
        this.loadCompanyName(data.companyID);
      } else if (data.firstname) {
        this.companyName = String(data.firstname);
      }
    }
    this.getAllModules();
    this.fetchAuditLogs();
  }

  getAllModules() {
    this.auditService.getAllModules().subscribe({
      next: (resp) => {
        if (resp?.data) {
          this.modules = (resp.data || []).filter(
            (moduleName: string) =>
              !this.excludedModules.has(this.normalizeModuleName(moduleName)),
          );
        }
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  getDateFormat(companyId: any) {
    this.companyService.getParametersById(companyId).subscribe({
      next: (resp) => {
        if (resp?.data?.date_format) {
          this.date = resp?.data?.date_format;
          this.dateFormat = resp?.data?.date_format.replace('mm', 'MM');
          this.angularDateFormat =
            this.commonService.convertPrimeNGToAngularFormat(this.date);
        }
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  private loadCompanyName(companyId: any): void {
    this.companyService.getCompanybyID(companyId).subscribe({
      next: (resp: any) => {
        this.companyName = String(resp?.data?.company_name || '').trim();
      },
      error: () => { /* no-op */ },
    });
  }
  // getMenuIdByName(menuName: string): void {
  //   this.menuService.getAllMenus().subscribe({
  //     next: (res: any) => {
  //       if (res?.data && Array.isArray(res.data)) {
  //         const menu = res.data.find(
  //           (m: any) => m.name?.trim().toLowerCase() === menuName.toLowerCase(),
  //         );

  //         if (menu) {
  //           this.menuId = menu.id;
  //           // console.log(`📦 Menu ID found for "${menuName}":`, this.menuId);
  //         } else {
  //           console.warn(`⚠️ No matching menu found for "${menuName}"`);
  //           this.menuId = 0;
  //         }
  //       } else {
  //         console.error('❌ Invalid response from getAllMenus()');
  //       }
  //     },
  //     error: (err) => {
  //       console.error('❌ Failed to load menu list', err);
  //     },
  //   });
  // }
  fetchAuditLogs(): void {
    const params: any = {
      module: this.filters.module || '',
      searchText: this.searchQuery || this.filters.searchText,
      excludeActions: 'SIGNIN,SIGNOUT',
      page: this.page - 1,
      size: this.pageSize,
      ...this.commonService.buildFilterPayload(this.filterPayload),
    };

    if (this.orderby) params['orderby'] = this.orderby;
    if (this.order) params['order'] = this.order;

    if (this.filters.amendmentFrom) {
      params.amendmentFrom = this.datePipe.transform(
        this.filters.amendmentFrom,
        'yyyy-MM-dd',
      );
    }
    if (this.filters.amendmentTo) {
      params.amendmentTo = this.datePipe.transform(
        this.filters.amendmentTo,
        'yyyy-MM-dd',
      );
    }

    this.auditService
      .getAuditLogs(params)
      .subscribe((resp: AuditLogResponse) => {
        const rows = resp?.data?.data?.rows || [];
        this.logs = rows.filter((row: AuditRow) => {
          const moduleName = this.normalizeModuleName(row?.['Form Name'] || '');
          return !this.excludedModules.has(moduleName);
        });
        this.totalRecords = resp?.data?.totalItems || 0;
        this.currentPage = (resp?.data?.currentPage || 1) - 1;
        if (this.myColumns.length === 0) this.buildColumns();
      });
  }

  onFilterChange(): void {
    this.page = 1;
    this.fetchAuditLogs();
  }

  handlePageChange(newPage: number): void {
    this.page = newPage;
    this.fetchAuditLogs();
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  get totalPages(): number[] {
    const pages = Math.ceil(this.totalRecords / this.pageSize);
    return Array.from({ length: pages }, (_, i) => i);
  }

  private buildExportParams(): any {
    const params: any = {
      excludeActions: 'SIGNIN,SIGNOUT',
    };
    if (this.filters.amendmentFrom) {
      params.amendmentFrom = this.datePipe.transform(
        this.filters.amendmentFrom,
        'yyyy-MM-dd',
      );
    }
    if (this.filters.amendmentTo) {
      params.amendmentTo = this.datePipe.transform(
        this.filters.amendmentTo,
        'yyyy-MM-dd',
      );
    }
    if (this.filters.module) {
      params.module = this.filters.module;
    }
    if (this.filters.searchText) {
      params.searchText = this.filters.searchText;
    }
    return params;
  }

  private triggerDownload(
    blob: Blob,
    fallbackName: string,
    disposition: string | null,
  ): void {
    const fileName =
      disposition?.match(/filename="([^"]+)"/)?.[1] ?? fallbackName;
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(url);
  }

  exportToExcel(): void {
    this.isMenuOpen = false;
    this.exportToExcelFallback();
  }

  private exportToExcelFallback(): void {
    const params: any = {
      ...this.buildExportParams(),
      page: 0,
      size: 10000,
    };

    this.auditService.getAuditLogs(params).subscribe({
      next: (resp: AuditLogResponse) => {
        const allLogs: AuditRow[] = resp?.data?.data?.rows || [];
        if (!allLogs.length) return;

        const headers = [
          'Employee Code',
          'Employee Name',
          'Form Name',
          'Field Name',
          'Old Value',
          'New Value',
          'Delete',
          'Effective Date',
          'Amendment By',
          'Amendment On',
          'Created On',
          'Created By',
          'Pay Period Start Date',
          'Pay Period End Date',
          'Month-Year',
        ];

        const rows = allLogs.map((row) => ({
          'Employee Code': row['Employee Code'] || '',
          'Employee Name': row['Employee Name'] || '',
          'Form Name': row['Form Name'] || '',
          'Field Name': row['Field Name'] || '',
          'Old Value': row['Old Value'] || '',
          'New Value': row['New Value'] || '',
          'Delete': row['Delete'] || 'false',
          'Effective Date': row['Effective Date'] || '',
          'Amendment By': row['Amendment By'] || '',
          'Amendment On': row['Amendment On'] || '',
          'Created On': row['Created On'] || '',
          'Created By': row['Created By'] || '',
          'Pay Period Start Date': row['Pay Period Start Date'] || '',
          'Pay Period End Date': row['Pay Period End Date'] || '',
          'Month-Year': row['Month-Year'] || '',
        }));

        const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([[], [], [], []]);

        const downloadDate = moment().format(
          this.commonService.convertPrimeNGToMomentFormat(this.dateFormat)
        );
        XLSX.utils.sheet_add_aoa(
          ws,
          [
            [`Downloaded Date: ${downloadDate}`],
            [this.companyName || ''],
            ['Audit Report'],
          ],
          { origin: 'A1' },
        );
        XLSX.utils.sheet_add_json(ws, rows, { header: headers, origin: 'A4' });

        const titleStyle: any = {
          font: { bold: true, sz: 12 },
          alignment: { horizontal: 'center' },
        };
        const downloadDateStyle: any = {
          font: { bold: true, sz: 11 },
          alignment: { horizontal: 'right' },
        };
        const dlCell = ws[XLSX.utils.encode_cell({ r: 0, c: 0 })];
        if (dlCell) dlCell.s = downloadDateStyle;
        const cnCell = ws[XLSX.utils.encode_cell({ r: 1, c: 0 })];
        if (cnCell) cnCell.s = titleStyle;
        const rnCell = ws[XLSX.utils.encode_cell({ r: 2, c: 0 })];
        if (rnCell) rnCell.s = titleStyle;

        ws['!merges'] = [
          { s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } },
          { s: { r: 1, c: 0 }, e: { r: 1, c: headers.length - 1 } },
          { s: { r: 2, c: 0 }, e: { r: 2, c: headers.length - 1 } },
        ];

        const headerStyle = {
          font: { bold: true, color: { rgb: 'FFFFFF' } },
          fill: { fgColor: { rgb: '4472C4' } },
          alignment: { horizontal: 'center' },
        };
        headers.forEach((_, i) => {
          const cell = ws[XLSX.utils.encode_cell({ r: 3, c: i })];
          if (cell) cell.s = headerStyle;
        });

        ws['!cols'] = headers.map((h) => ({ wch: Math.max(h.length + 2, 18) }));

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Audit Report');
        XLSX.writeFile(
          wb,
          `Audit_Report_${this.datePipe.transform(new Date(), 'yyyyMMdd_HHmm')}.xlsx`,
        );
      },
      error: (err) => console.error('Fallback Excel export failed', err),
    });
  }

  exportToPdf(): void {
    this.isMenuOpen = false;
    const params = this.buildExportParams();
    this.auditService.exportPdf(params).subscribe({
      next: (resp) => {
        if (resp.body) {
          this.triggerDownload(
            resp.body,
            `Audit_Report_${this.datePipe.transform(new Date(), 'ddMMMyyyy')}.pdf`,
            resp.headers.get('Content-Disposition'),
          );
        }
      },
      error: (err) => console.error('PDF export failed', err),
    });
  }

  buildColumns(): void {
    this.myColumns = [
      { field: 'Employee Code', header: 'Employee Code' },
      { field: 'Employee Name', header: 'Employee Name' },
      { field: 'Form Name', header: 'Form Name' },
      { field: 'Field Name', header: 'Field Name' },
      { field: 'Old Value', header: 'Old Value' },
      { field: 'New Value', header: 'New Value' },
      { field: 'Delete', header: 'Delete' },
      { field: 'Effective Date', header: 'Effective Date', isDate: true },
      { field: 'Amendment By', header: 'Amendment By' },
      { field: 'Amendment On', header: 'Amendment On', isDate: true },
      { field: 'Created On', header: 'Created On', isDate: true },
      { field: 'Created By', header: 'Created By' },
      {
        field: 'Pay Period Start Date',
        header: 'Pay Period Start Date',
        isDate: true,
      },
      {
        field: 'Pay Period End Date',
        header: 'Pay Period End Date',
        isDate: true,
      },
      { field: 'Month-Year', header: 'Month-Year' },
    ];
  }

  handleFilterChange(payload: any): void {
    this.filterPayload = payload;
    if (payload) {
      if (payload.orderby !== undefined) this.orderby = payload.orderby;
      if (payload.order !== undefined) this.order = payload.order;
      if (payload.page !== undefined) this.page = payload.page + 1;
      if (payload.pageSize !== undefined) this.pageSize = payload.pageSize;
    }
    this.fetchAuditLogs();
  }

  onSearchChange(): void {
    if (this.searchDebounceTimer) clearTimeout(this.searchDebounceTimer);
    this.searchDebounceTimer = setTimeout(() => {
      this.page = 1;
      this.fetchAuditLogs();
    }, 400);
  }
}
